/**
 * @Description 点位测评详情
 */

import { FC, useContext, useEffect, useRef, useState } from 'react';
import { useMethods } from '@lhb/hook';
import { MapThemeEnum } from '@/layout/ts-config';
// import cs from 'classnames';
import styles from './index.module.less';
// 使用组件库的地图组件，逐步替换
import V2AMap from '@/common/components/Map/V2AMap';
import Legend from './Legend';
import Rail from './Rail';
import BackCore from './BackCore';
// import MarkerCluster from './MapPoint/MarkerCluster';
import CompetitorsMarker from './MapPoint/CompetitorsMarker';
import FamousMarker from './MapPoint/FamousMarker';
import StoreBrandMarker from './MapPoint/StoreBrandMarker';
import CommonRimMarker from './MapPoint/CommonRimMarker';
import cs from 'classnames';
import UserInfoContext from '@/layout/context';
// import { debounce } from '@lhb/func';
// import { useBigdataFn } from '@/common/utils/bigdata';
export const mapContainer = 'mapContainer';

const FirstScreenMap: FC<any> = ({
  mapIns,
  detail,
  mainHeight,
  legendData,
  isMallType,
  storeChecked,
  surroundingChecked,
  setMapIns,
  // curSurroundDetail, // 周边配套选中的表格项
  // setCurSurroundDetail, // 设置周边配套选中的表格项
  curDetail, // 经营门店选中的表格项
  setCurDetail, // 设置经营门店选中的表格项
  tenantId,
  drawerData,
  rangeMarkerRef,
  isOpenHeatMap
}) => {
  // const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [isBack, setIsBack] = useState(false);
  const [famousBrandData, setFamousBrandData] = useState<any[]>([]); // 知名品牌数据
  const [competitorsData, setCompetitorsData] = useState<any[]>([]); // 竞品数据
  const [commonStoreData, setCommonStoreData] = useState<any>({}); // 经营门店
  const [commonRimData, setCommonRimData] = useState<any>({}); // 周边配套数据
  // const [isShowZoom, setIsShowZoom] = useState<boolean>(false);// 是否到展示知名品牌、竞品品牌、经营门店的聚合的级别
  const contentMarkerRef = useRef<any>(null);
  const { mapConfig } = useContext(UserInfoContext); // 租户信息

  // const isShowCluster = useMemo(() => {
  //   if (!isShowZoom) return false;
  //   const count = (famousBrandData?.length || 0) +
  //   (competitorsData?.length || 0) +
  //   Object.keys(commonStoreData)?.reduce((acc, key) => {
  //     return acc + (commonStoreData[key].length || 0);
  //   }, 0);
  //   // 是否聚合
  //   const isCluster = count > 60 && isShowZoom;
  //   // 如果之前打开了经营门店的context，在聚合级别下不展示
  //   if (isCluster && contentMarkerRef.current?.getExtData()?.isStore) {
  //     mapIns.remove(contentMarkerRef.current);
  //     setCurDetail(null);
  //   }
  //   // 当视图为3km的地图比例尺，且500m以内的经营门店数超过60家则显示小聚合
  //   return isCluster;
  // }, [famousBrandData, competitorsData, commonStoreData, isShowZoom]);

  const handleDetailToNull = () => {
    setCurDetail(null);
    // setCurSurroundDetail(null);
  };
  const methods = useMethods({
    mapLoadedHandle: (ins: any) => {
      setMapIns(ins);
      ins.setZooms([13.5, 20]);
    },
    // onClickMarker() {
    //   bigdataFn('4e6abada-ed03-4719-b8f6-237cee100584', '详情-地图-点击图标', '点击了详情-地图-点击图标', { op_block: '开店区域-详情页', op_event: ``, });
    // }
  });

  // const handlerZoomEnd = debounce(() => {
  //   bigdataFn('4cf4ecd1-17e0-4f08-bc4f-dd199ef80125', '详情-地图-放大/缩小一次', '详情-地图-放大/缩小一次', { op_block: '开店区域-详情页', op_event: ``, });
  // }, 200);
  // const handlerMoveend = debounce(() => {
  //   bigdataFn('1392958f-a3fa-4db6-a9e6-afec91b43486', '详情-地图-拖动一次', '详情-地图-拖动一次', { op_block: '开店区域-详情页', op_event: ``, });
  // }, 200);

  useEffect(() => {
    // 如果curDetail为空，则移出contentMarkerRef
    if (!curDetail) {
      contentMarkerRef.current && mapIns?.remove(contentMarkerRef.current);
    }
  }, [curDetail]);

  useEffect(() => {
    if (!mapIns) return;
    mapIns.setMapStyle(`amap://styles/${mapConfig?.bg || MapThemeEnum.NORMAL}`);
  }, [mapIns, mapConfig]);

  // 埋点注释
  // useEffect(() => {
  //   if (!mapIns) return;
  //   mapIns.on('zoomend', handlerZoomEnd);
  //   mapIns.on('moveend', handlerMoveend);

  //   return () => {
  //     mapIns.off('zoomend', handlerZoomEnd);
  //     mapIns.off('moveend', handlerMoveend);
  //   };
  // }, [mapIns]);

  return (
    <div className={styles.firstScreenMapCon}>
      <div className={cs(styles.mapContainer, mapContainer)}>
        <V2AMap
          mapOpts={{
            zooms: [10, 20],
            showIndoorMap: true,
          }}
          loaded={methods.mapLoadedHandle}
          plugins={[
            'AMap.MarkerCluster',
            'AMap.HeatMap'
          ]}
        >
          {/* 图例 */}
          <Legend
            isMallType={isMallType}
            detail={detail}
            mainHeight={mainHeight}
            legendData={legendData}
            storeChecked={storeChecked}
            surroundingChecked={surroundingChecked}
            setCompetitorsData={setCompetitorsData}
            setFamousBrandData={setFamousBrandData}
            setCommonStoreData={setCommonStoreData}
            setCommonRimData={setCommonRimData}
            tenantId={tenantId}
            drawerData={drawerData}
            isOpenHeatMap={isOpenHeatMap}
          />
          {/* 商圈围栏以及默认的围栏 */}
          <Rail
            mapIns={mapIns}
            detail={detail}
            isBack={isBack}
            setIsBack={setIsBack}
            rangeMarkerRef={rangeMarkerRef}
          />
          {/* 回到商圈重心位置 */}
          <BackCore
            setIsBack={setIsBack}
          />
          {/* 知名品牌 */}
          <FamousMarker
            mapIns={mapIns}
            data={isOpenHeatMap ? [] : famousBrandData}
            contentMarkerRef={contentMarkerRef}
            curDetail={curDetail}
            setCurDetail={setCurDetail}
            handleDetailToNull={handleDetailToNull}
            // onClickMarker={methods.onClickMarker}
          />
          {/* 竞品门店 */}
          <CompetitorsMarker
            mapIns={mapIns}
            data={isOpenHeatMap ? [] : competitorsData}
            contentMarkerRef={contentMarkerRef}
            curDetail={curDetail}
            setCurDetail={setCurDetail}
            handleDetailToNull={handleDetailToNull}
            // onClickMarker={methods.onClickMarker}
          />
          {/* 经营门店（除知名品牌、竞品门店外） */}
          <StoreBrandMarker
            mapIns={mapIns}
            data={isOpenHeatMap ? {} : commonStoreData}
            contentMarkerRef={contentMarkerRef}
            curDetail={curDetail}
            setCurDetail={setCurDetail}
            handleDetailToNull={handleDetailToNull}
            // onClickMarker={methods.onClickMarker}
          />
          {/* 周边配套数据 */}
          <CommonRimMarker
            mapIns={mapIns}
            data={isOpenHeatMap ? {} : commonRimData}
            contentMarkerRef={contentMarkerRef}
            curDetail={curDetail}
            setCurDetail={setCurDetail}
            handleDetailToNull={handleDetailToNull}
            // onClickMarker={methods.onClickMarker}
          />
          {/* 经营门店点聚合 */}
          {/* <MarkerCluster
            mapIns={mapIns}
            famousBrandData={famousBrandData}
            competitorsData={competitorsData}
            commonStoreData={commonStoreData}
            isShowCluster={isShowCluster}
            setIsShowZoom={setIsShowZoom}
            legendData={legendData}
          /> */}
        </V2AMap>
      </div>
    </div>
  );
};

export default FirstScreenMap;
